"use strict";

define('model/person',['./base'], function (BaseModel) {
  var Person = BaseModel.extend({
    urlRoot: '/rs/api/person',
    virtual: {
      'displayName': function displayName() {
        return [this.get('firstName'), this.get('lastName')].join(' ');
      },
      'boldHtmlDisplayName': function boldHtmlDisplayName() {
        var firstName = Handlebars.escapeExpression(this.get('firstName')),
          lastName = Handlebars.escapeExpression(this.get('lastName'));
        return new Handlebars.SafeString(firstName + ' <b>' + lastName + '</b>');
      },
      'primaryPhone': function primaryPhone() {
        var phones = this.get('phones') || [],
          primary = null,
          primaryPhone = '';
        primary = _.find(phones, function (phone, index, list) {
          return phone.preferred == true || list.length == 1 || index == list.length - 1;
        });
        if (primary) {
          primaryPhone = primary.extension ? primary.number + ' ext. ' + primary.extension : primary.number;
        }
        return primaryPhone;
      },
      'primaryEmail': function primaryEmail() {
        var emails = this.get('emails') || [],
          primary = null;
        primary = _.find(emails, function (email, index, list) {
          return email.preferred == true || list.length == 1 || index == list.length - 1;
        });
        return primary && primary.emailAddress || '';
      }
    }
  }, {
    allByRoleId: function allByRoleId(id) {
      return this.createCollection('/rs/api/role/:roleId/person').params({
        roleId: id
      });
    },
    allFinder: function allFinder() {
      return this.createCollection('/rs/api/person/finder');
    },
    all: function all() {
      return this.createCollection('/rs/api/person');
    }
  });
  return Person;
});

